export default __webpack_public_path__ + "static/media/QSGRW_Tools_Extract.dd137e9b.png";